import { createReducer, on } from '@ngrx/store';
import { HeartbeatActions } from './heartbeat.actions';
import { heartbeatState } from './heartbeat.state';

/**
 * @description Reducer for heartbeat state management.
 * @exports
 */
export const heartbeatReducer = createReducer(
  // Initial state for heartbeat
  heartbeatState,
  // Handle the Send Message action
  on(HeartbeatActions.sendMessage, (state, { message }) => ({
    ...state,
    message
  })),
  // Handle the Set Purchase Order Payment action
  on(
    HeartbeatActions.setPurchaseOrderPayment,
    (state, purchaseOrderPayment) => ({
      ...state,
      purchaseOrderPayment
    })
  )
);
